import React, { useEffect, useState, useRef } from "react";

import {
  MdAssignment,
  MdLanguage,
  MdKeyboardArrowDown,
  MdMenu,
} from "react-icons/md";
import { RxHamburgerMenu } from "react-icons/rx";
import { AiOutlineMenuUnfold } from "react-icons/ai";
import { BiHeadphone, BiSidebar } from "react-icons/bi";
import { GrClose, GrAdd, GrFormNext  } from "react-icons/gr";
import { useNavigate, useLocation } from 'react-router-dom';

const Nav = () => {
  const [height, setHeight] = useState("6rem"); // 초기 높이 설정
  const [position, setPosition] = useState(0);
  const [currentSection, setCurrentSection] = useState(window.location.hash);
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0); // FullPage.js 섹션 인덱스
  const [isWhiteBackground, setIsWhiteBackground] = useState(false); // 흰색 배경 여부
  const [menuLev1, setMenuLev1] = new useState([]);
  const [menuLev2, setMenuLev2] = new useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [subMenuOpen, setsubMenuOpen] = useState({});
  const menuRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();


  // 자식 요소에 마우스가 올라갔을 때 호출할 함수
  const handleMouseEnter = () => {
    setHeight("260px"); // 높이를 증가
  };

  // 자식 요소에서 마우스가 벗어났을 때 호출할 함수
  const handleMouseLeave = () => {
    setHeight("6rem"); // 높이를 초기 값으로 복원
  };


  const checkScrollPosition = () => {
    const scrollPosition = window.scrollY;
    setPosition(window.scrollY);
  };

  const handleHashChange = () => {
    setCurrentSection(window.location.hash);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuClick = (menuId) => {
 
    setsubMenuOpen(prevState => ({
      [menuId]: !prevState[menuId]
    }));
  };

  const handleMenuMoveClick = (e, url, subMenuId, closeMobileMenu = false) => {
   console.log('메뉴 클릭:', url, subMenuId);

    // href="#" 기본 동작(페이지 최상단 점프) 방지
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }

    // 모바일 메뉴 닫기
    if (closeMobileMenu) {
      setIsMenuOpen(false);
    }
    
    const sectionIndex = parseInt(subMenuId);

    // 같은 페이지 안에서의 이동이면 스크롤만 (navigate 생략 → 이중 스크롤 방지)
    if (location.pathname === url) {
      if (typeof window.scrollToSection === 'function') {
        window.scrollToSection(sectionIndex);
        setCurrentSectionIndex(sectionIndex);
      }
      return;
    }

    // 다른 페이지로 이동: 라우팅 후 렌더되면 해당 섹션으로 스크롤
    navigate(url, {
      state: {
        subMenuId: sectionIndex, // 숫자로 변환하여 전달
      },
    });
    setTimeout(() => {
      if (typeof window.scrollToSection === 'function') {
        window.scrollToSection(sectionIndex);
      }
    }, 400);
  };

  const handleLogoClick = () => {
    console.log('로고 클릭 - 새로고침');
    
    // 모바일 메뉴 닫기
    setIsMenuOpen(false);
    
    // 메인 페이지로 새로고침
    window.location.href = '/';
  };


  useEffect(() => {
    window.addEventListener('scroll', checkScrollPosition);
    window.addEventListener('hashchange', handleHashChange);

    // FullPage.js 섹션 변경 감지를 위한 전역 함수 등록
    window.updateNavSection = (sectionIndex) => {
      setCurrentSectionIndex(sectionIndex);
      console.log('Nav에서 섹션 변경 감지:', sectionIndex);
    };

    // Nav 전용 업데이트 함수 (Main.js와 충돌 방지)
    window.updateNavOnly = (sectionIndex) => {
      console.log('🔄 Nav 전용 섹션 변경 감지:', sectionIndex);
      console.log('🔄 이전 currentSectionIndex:', currentSectionIndex);
      
      // 상태 업데이트
      setCurrentSectionIndex(sectionIndex);
      
      // 흰색 배경 적용 여부 결정
      const shouldBeWhite = sectionIndex > 0;
      setIsWhiteBackground(shouldBeWhite);
      
      console.log('🔄 새로운 currentSectionIndex:', sectionIndex);
      console.log('🔄 배경 색상 설정:', shouldBeWhite ? '✅ 흰색' : '❌ 투명');
      
      // 즉시 스타일 업데이트 강제
      setTimeout(() => {
        console.log('🔄 1초 후 currentSectionIndex 재확인:', currentSectionIndex);
        console.log('🔄 1초 후 isWhiteBackground 재확인:', isWhiteBackground);
      }, 1000);
    };

    // 섹션 하이라이트는 public/main.js의 IntersectionObserver가
    // window.updateNavOnly / window.updateNavSection 을 호출해 처리합니다.

    return () => {
      window.removeEventListener('scroll', checkScrollPosition);
      window.removeEventListener('hashchange', handleHashChange);

      // 전역 함수 정리
      if (window.updateNavSection) {
        delete window.updateNavSection;
      }
      if (window.updateNavOnly) {
        delete window.updateNavOnly;
      }
    };

  }, []);


  useEffect(() => {
    setMenuLev1([
      { menuId: "Main", menuNm: "SOLCOMBINE" ,url:"/", subMenuYn : true},
      { menuId: "Prcs", menuNm: "SERVICE",url:"/Prcs", subMenuYn : true },
      //{ menuId: "in", menuNm: "장례정보",url:"#" },
      { menuId: "Cnct", menuNm: "CONTACT", subMenuYn : false ,url:"/Cnct" },
     // { menuId: "pm", menuNm: "사전예약가입", subMenuYn : false,url:"https://form.office.naver.com/form/responseView.cmd?formkey=YjQxMjAwMzQtYzBiNC00YjAwLThhODEtM2Q5YjY2MGViMmI3&sourceId=urlshare" },
    ]);

    setMenuLev2([
      { menuId: "", menuNm: "SOLCOMBINE", url : '/',  subMenuId: "0", subMenuNm: "솔컴바인", },
      { menuId: "Main", menuNm: "SOLCOMBINE", url : '/',  subMenuId: "1", subMenuNm: "사업분야", },
      { menuId: "Main", menuNm: "SOLCOMBINE", url : '/',  subMenuId: "2", subMenuNm: "회사소개", },
      { menuId: "Main", menuNm: "SOLCOMBINE", url : '/',  subMenuId: "3", subMenuNm: "고객문의", },
      { menuId: "Main", menuNm: "SERVICE", url : '/Prcs',  subMenuId: "0", subMenuNm: "서비스", },
      { menuId: "Main", menuNm: "SERVICE", url : '/Prcs',  subMenuId: "1", subMenuNm: "진행절차", },
      { menuId: "Main", menuNm: "SERVICE", url : '/Prcs',  subMenuId: "2", subMenuNm: "솔루션", },
      { menuId: "Prcs", menuNm: "SERVICE", url : '/Prcs',  subMenuId: "3", subMenuNm: "유지보수&호스팅", },
      { menuId: "pd", menuNm: "상품소개",       url : '/Cnct',  subMenuId: "Cnct", subMenuNm: "", },
      { menuId: "pd", menuNm: "상품소개",       url : '/Pd0102',  subMenuId: "pd0102", subMenuNm: "알뜰가족형", },
      { menuId: "pd", menuNm: "상품소개",       url : '/Pd0103',  subMenuId: "pd0103", subMenuNm: "일반형", },
      { menuId: "pd", menuNm: "상품소개",       url : '/Pd0104',  subMenuId: "pd0104", subMenuNm: "고급형", },
    ]); 
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        // 메뉴 외부 클릭 시 로직
        setIsMenuOpen(false);
      }
    }
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef]);

  // currentSectionIndex 변경 감지를 위한 useEffect 추가
  useEffect(() => {
    console.log('🎯 currentSectionIndex 실제 변경됨:', currentSectionIndex);
    
    // currentSectionIndex가 변경되면 자동으로 isWhiteBackground 업데이트
    const shouldBeWhite = currentSectionIndex > 0;
    console.log('🎯 배경 스타일 조건:', shouldBeWhite ? '✅ 흰색 배경 적용' : '❌ 투명 배경 적용');
    
    if (isWhiteBackground !== shouldBeWhite) {
      setIsWhiteBackground(shouldBeWhite);
      console.log('🎯 isWhiteBackground 자동 업데이트:', shouldBeWhite);
    }
  }, [currentSectionIndex, isWhiteBackground]);

  // isWhiteBackground 변경 감지를 위한 useEffect 추가
  useEffect(() => {
    console.log('🎯 isWhiteBackground 실제 변경됨:', isWhiteBackground);
    console.log('🎯 스타일 적용:', isWhiteBackground ? '✅ 흰색 배경 & 검은색 텍스트' : '❌ 투명 배경 & 흰색 텍스트');
  }, [isWhiteBackground]);

  // 디버깅용 - 렌더링 시 currentSectionIndex 확인
  console.log('🎨 Nav 렌더링 - currentSectionIndex:', currentSectionIndex, 'isWhiteBackground:', isWhiteBackground);
  console.log('🎨 Nav 배경 스타일 적용 여부:', isWhiteBackground ? '✅ 흰색 배경' : '❌ 투명 배경');

  return (
    <div>
      {/* 모바일 햄버거 버튼 */}
      <div className="lg:hidden w-full fixed top-0 z-50">
        <button
          type="button"
          className="w-full flex justify-end p-2"
          onClick={toggleMenu}
        >
          <RxHamburgerMenu
            className="text-gray-500/90"
            size={30}
          />
        </button>
      </div>

      {/* 데스크톱 메뉴 */}
      <div className="hidden lg:block">
        <header //hover:overflow-visible hover:translate-b-1 hover:duration-200 
          id="header"
          className={` header group overflow-hidden h-{height} fixed inset-x-0 w-full z-50 shadow-lg cursor-pointer
                      hover:!bg-white hover:shadow-2xl transition-all duration-300
                      ${isWhiteBackground ? 'bg-white/95 shadow-2xl backdrop-blur-md hover:bg-white' : ''}
                      ${isMenuOpen ? 'hidden' : ''}         
                  `}
          style={{height:height}}
        >
        
          <div className="flex header-inner  h-24 justify-between border-b border-gray-300/30">
            <h1 className="logo flex w-[100px] lg:w-[180px] h-[40px] ms-5 mt-[30px] items-center">
              <div 
                className="flex items-center cursor-pointer transition-all duration-300 hover:scale-105"
                onClick={handleLogoClick}
              >
                <img 
                  src={require('../images/common/sc_logo2.png')} 
                  alt="SOLCOMBINE Logo"
                  className={`h-[50px] w-auto pb-1 transition-all duration-300 hover:drop-shadow-lg
                           ${isWhiteBackground ? 'brightness-110' : 'group-hover:brightness-110'}`}
                />
                <span translate="no" className="notranslate text-xl lg:text-2xl font-[GODO]
                               transition-all duration-300 drop-shadow-lg">
                  <span className="text-red-500">SOL</span><span className={`transition-all duration-300 ${isWhiteBackground ? 'text-black' : 'text-white group-hover:text-black'}`}>COMBINE</span>
                </span>
              </div>
            </h1>

            <div className="flex space-x-[150px]">
              <div className="">
                <ul
                  className="gnb flex flex-wrap justify-end   overflow-hidden hover:overflow-visible "
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  {menuLev1.map((e, i)=> {

                return (
                      <li key={e.menuId} className="menu group/company">
                        <a
                          href={e.url}
                          translate="no"
                          className={`notranslate menu-link opacity-80 pt-[35px] flex justify-center text-lg px-[50px] items-center text-center transition-all duration-300
                                    ${isWhiteBackground ? 'text-black' : 'text-white group-hover:text-black'} hover:!text-red-600`}>
                          {e.menuNm}
                        </a>
                        <ul className={`depth h-full px-10 mt-[31px]
                                          ${e.subMenuYn === true ? 'group-hover/company:bg-gray-100/80' : ''}
                                      `}>
                          {menuLev2.map((subItem, i) => { // 'a' 대신 'subItem' 사용
                            if (e.menuNm === subItem.menuNm) {
                              return (
                                <li key={subItem.subMenuId} className="depth-item text-center pt-4 text-sm text-[#838789] hover:transition-colors hover:duration-500 hover:text-red-600">
                                  <a href="#" className="depth-link" onClick={(e) => handleMenuMoveClick(e, subItem.url, subItem.subMenuId)} >
                                    {subItem.subMenuNm}
                                    
                                  </a>
                                </li>
                              );
                            }
                            return null; // 조건에 맞지 않는 경우 null 반환
                          })}
                        </ul>
                      </li>
                    );
                  })}

                </ul>
              </div>

              <div className="quick-wrap clearfix flex items-center ">
                <a
                  href="tel:1800-8477"
                  className={`btn-procurement flex items-center justify-center border rounded-full w-[150px] lg:w-[190px] h-[40px] opacity-50 me-5 lg:me-2 text-center border-[3px] leading-[34px] transition-all duration-300
                            ${isWhiteBackground ? 'text-black border-gray-400' : 'text-white group-hover:text-black group-hover:border-gray-400'}
                            hover:!border-gray-600 hover:text-gray-900`}
                >
                  <BiHeadphone className="me-3 w-[14px] "></BiHeadphone>
                  <span className="poppins ">
                    <span className="hide_1280">1800-8477</span>
                    </span>
                </a>            
                
              </div>
            </div>
          </div>

        </header>
      </div>
      

      

      {/* 모바일 사이드 메뉴 */}
      <div ref={menuRef} 
          className={`lg:hidden bg-white w-[90%] h-full end-0 fixed z-50 shadow-xl transition-all duration-300 overflow-hidden
                      ${isMenuOpen ? 'max-w-[300px]' : 'max-w-0'} `}>
        <div className="flex justify-between py-4">
            <div>
              <h1 className="logo flex w-[120px] lg:w-[160px] h-[40px] ms-5 items-center">
                <div 
                  className="flex items-center cursor-pointer transition-all duration-300 hover:scale-105"
                  onClick={handleLogoClick}
                >
                  <img 
                    src={require('../images/common/sc_logo.png')} 
                    alt="SOLCOMBINE Logo"
                    className="h-[30px] w-auto mr-2 transition-all duration-300 hover:drop-shadow-lg"
                  />
                  <span translate="no" className="notranslate text-red-600 text-lg font-[GODO] transition-all duration-300 hover:text-red-500 drop-shadow-lg">
                    SOLCOMBINE
                  </span>
                </div>
              </h1>
            </div>
            <div className="mr-5">
             <GrClose   size={26}   onClick={toggleMenu} />

            </div>
          
        </div>
        <div className="flex justify-center">
          <a href="tel:1577-5424"
                                className=" flex items-center justify-center   
                        border rounded-full w-[190px] h-[40px]  me-2 
                        text-center border-[3px] leading-[34px]  border-red-400/60          
                        ">
              <BiHeadphone className="me-3 w-[14px] "></BiHeadphone>
              <span className="poppins ">
                <span className="">1577-5424</span>
                </span>
            </a>            

        </div>
        <ul
              className="gnb divide-y  mt-3"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {menuLev1.map((e, i)=> {

                  return(
                    <li key={e.menuId}  className="menu group/company w-full ">
                    
                    
                    <a
                      href={e.url}
                      translate="no"
                      className={`notranslate menu-link py-3 flex justify-start ps-5 text-lg  w-full
                                  ${subMenuOpen[e.menuId] ? 'text-red-600 ' : ''}
                              `}
                      onClick={() => handleMenuClick(e.menuId)}
                    >
                      <div className="flex items-center space-x-3">
                      {e.subMenuYn ? <GrAdd /> : <GrFormNext />}
                        <div className="text-lg">{e.menuNm}</div>
                      </div>
                    </a>
                    <ul className={`depth  h-full px-10 transition-all duration-300 overflow-hidden bg-gray-100
                                  ${subMenuOpen[e.menuId] ? 'max-h-[500px]' : 'max-h-0'}
                    `}
                    >
                    
                    {menuLev2.map((a,i) => {
                      if(e.menuNm === a.menuNm){
                        return(
                            <React.Fragment key={a.subMenuId}>
                            <li  className="depth-item  py-3 text-base text-[#838789]
                                            ">
                              <a href="#" className="depth-link" onClick={(e) => handleMenuMoveClick(e, a.url, a.subMenuId, true)}>
                                {a.subMenuNm}
                              </a>
                            </li>
                            </React.Fragment>
                          )
                        }
                      })}
                      </ul>
                  </li>
                  );
              })}

            </ul>

      </div>

    

     
    </div>
  );
};

export default Nav;
